module.exports = __webpack_public_path__ + "img/472.921b9758.jpg";